import { render, staticRenderFns } from "./AppChatStaffSelector.vue?vue&type=template&id=299d4392&scoped=true&"
import script from "./AppChatStaffSelector.vue?vue&type=script&lang=ts&"
export * from "./AppChatStaffSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AppChatStaffSelector.vue?vue&type=style&index=0&id=299d4392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299d4392",
  null
  
)

export default component.exports